/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";

export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'single',
    profile: {
        p_name_col_name: 'Material ID', // or "Material"
        p_name_col_width: 80,
        p_name_col_min_width: 80,

        p_description_col_name: 'Description',

        bu_col_name: 'Source system',
        hideNoBuFilterInCategorization: true,
        showBuWithId: true,





        allowIncompleteTaxonomy: true,
        showUncategorizedSubBars: true,

        synergyDashboardShowBusinessUnits: true, // Source System

        synergyDashboardShowPlantFilter: true,



        gotoBuFilterInSample: true,


        enableVertexAiCategorizationIntegrationForStaff: true,

        searchConfiguration: 'default_p_desc',

        locale: 'af',
        currency: 'ZAR',

        initialGroupBySupplierInactive: true,
        /*@formatter:off*/
        categorizationReviewSubRowRelationData: [{
            relation: "part",
            columns: [
                {db_column: "p_description", colSpec: {cls: '', txt: 'Description', columnFieldId: 'p_description', width: 180, minWidth: 80}},
                {db_column: "p_gl_name", colSpec: {cls: 'col-p_gl_name', txt: 'GL Name', columnFieldId: 'p_gl_name', width: 50}},
                {db_column: "p_gl_code", colSpec: {cls: 'col-p_gl_code', txt: 'GL Code', columnFieldId: 'p_gl_code', hideInTable: true}},

                {db_column: "c_code", colSpec: {cls: 'col-c_code', txt: 'Plant Code', columnFieldId: 'c_code', hideInTable: true}},
                {db_column: "sap_plant_description", colSpec: {txt: 'Plant Name', columnFieldId: 'sap_plant_description'}},

                {db_column: "cc_code", colSpec: {cls: 'col-c_code', txt: 'Profit Center Code', columnFieldId: 'cc_code', hideInTable: true}},
                {db_column: "cc_description", colSpec: {cls: 'col-c_description', txt: 'Cost Center Name', columnFieldId: 'cc_description'}},

                {db_column: "p_mat_group_code", colSpec: {cls: 'col-p_mat_group_code', txt: 'Material Group', columnFieldId: 'p_mat_group_code'}},
                {db_column: "p_mat_group_description", colSpec: {cls: 'col-p_mat_group_description', txt: 'Short Text', columnFieldId: 'p_mat_group_description'}},

                {db_column: "p_po_line_number", colSpec: {cls: 'col-p_po_line_number', txt: 'Item', columnFieldId: 'p_po_line_number'}},
                {db_column: "p_inv_id", colSpec: {cls: 'col-p_inv_id', txt: 'Document No', columnFieldId: 'p_inv_id'}},

                {db_column: "p_extra_1", colSpec: {cls: '', txt: 'PO Text', columnFieldId: 'p_extra_1'}},
                {db_column: "p_extra_2", colSpec: {cls: '', txt: 'PO Name', columnFieldId: 'p_extra_2'}},
            ]
        }],
        /*@formatter:on*/

        hideCards: [
            'koi-ppv',
            'koi-spend-concentration',
        ],

        supplierStandAloneFilter: '(default)', // See CAT-3590 before changing this
        disableSupplierNormalizationAiModel: true,


        showSupplierIdInSupplierNormalization: true,

        parentSupplierAltName: 'Normalized Supplier',

        showL4InOpportunityDashboard: true,

        enableProcChat: true,
        enableGoldenRecord: true,
    },
}
